
import {NgModule, Optional, SkipSelf, ModuleWithProviders, ErrorHandler} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ExceptionService} from './exception.service';
import {AppPreloadStrategy} from './preload-strategy';
import {EntityService} from './entity.service';
import {SpinnerModule} from './spinner/spinner.module';
import {ToastModule} from './toast/toast.module';
import {AppTranslateModule} from './translate/translate.module';
import {TranslatePipe} from 'ng2-translate';
import {NotifyModule} from './notify/notifier.module';
import {TermsComponent} from './terms/terms.component';
import {GoogleAnalyticsEventsService} from './googleAnalyticsService';
import {WindowRef} from './window.service';
import {FooterComponent} from './footer/footer.component';

@NgModule({
  imports: [
    CommonModule,
    SpinnerModule,
    ToastModule,
    AppTranslateModule,
    NotifyModule
  ],
  exports: [
    SpinnerModule,
    ToastModule,
    AppTranslateModule,
    TranslatePipe,
    NotifyModule,
    TermsComponent,
    FooterComponent

  ],
  providers: [GoogleAnalyticsEventsService, WindowRef],
  declarations: [
    TermsComponent,
    FooterComponent
  ],

})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        {provide: ErrorHandler, useClass: ExceptionService },
        AppPreloadStrategy,
        EntityService
      ],
    };
  };
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/core/core.module.ts